export class ClienteReport {
    constructor(
        public razon_social: string = "",
        public direccion: string = "",
        public cuenta: string = "",
        public ci: string = "",
        public circuito: string = "",
        public medidor: string = "",
        public catastro: string = "",
        public actividad: string = "",
        public categoria: string = "",
        public fecha: string = "",
        public ventanilla: number = 0,
    ) {
    }
}